"use strict";
/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullLogging = void 0;
class NullLogging {
    event(event) { }
    error(e) { }
    log(e) { }
}
exports.NullLogging = NullLogging;
